import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import PDFGenerator from "../PDFGenerator";
import GenerateButton from "../GenerateButton";
import { write, utils } from "xlsx";
import { saveAs } from "file-saver";
import "react-toastify/dist/ReactToastify.css";

const Vessel = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  console.log(authtoken);
  // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("vessels");
  const [data, setData] = useState(undefined);
  const [bookingReportData, setBookingReportData] = useState(undefined);
  const [VesselCode, setVesselCode] = useState("");
  const [VesselDesc, setVesselDesc] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [Active, setActive] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [oldVesselCode, setOldVesselCode] = useState("");
  let [duplicateVal, setDuplicateVal] = useState(false);
  const [vesEmpty, setVesEmpty] = useState(false);
  const [vesDescEmpty, setVesDescEmpty] = useState(false);
  const [showPDFGenerator, setShowPDFGenerator] = useState(false);

  function generateReport(bookingReportData) {
    const worksheet = utils.json_to_sheet(bookingReportData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Report");
    const excelData = write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "report.xlsx");
  }
  const handleGenerateReport = () => {
    generateReport(bookingReportData);
  };

  const handleButtonClickPDF = () => {
    setShowPDFGenerator(!showPDFGenerator);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setVesselCode("");
    setVesselDesc("");
    setDuplicateVal(false);
  };

  function setSelectedRow(rowid) {
    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        setSelectRowData(selectRowData);
        setVesselCode(
          selectRowData.vessels.vessel_code
            ? selectRowData.vessels.vessel_code
            : ""
        );
        setOldVesselCode(
          selectRowData.vessels.vessel_code
            ? selectRowData.vessels.vessel_code
            : ""
        );
        setVesselDesc(
          selectRowData.vessels.vessel_description
            ? selectRowData.vessels.vessel_description
            : ""
        );
        if (
          selectRowData.vessels.active_status
            ? selectRowData.vessels.active_status == 1
            : ""
        ) {
          setIsChecked(true);
        } else {
          setIsChecked(false);
        }
        setBtnActive(false);
      });
  }

  const edditRow = (event) => {
    event.preventDefault();
    if (oldVesselCode == VesselCode) {
      if (VesselCode.length == 0) {
        toast.error("Vessel Code can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setVesEmpty(true);
        return;
      } else {
        setVesEmpty(false);
      }

      if (VesselDesc.length == 0) {
        toast.error("Vessel Description can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setVesDescEmpty(true);
        return;
      } else {
        setVesDescEmpty(false);
      }

      if (selectRowData !== "") {
        const inputData = {
          vessel_code: VesselCode,
          vessel_description: VesselDesc,
          active_status: isChecked ? 1 : 0,
        };
        console.log(inputData);
        axios
          .post(
            `${baseUrl}${pageComponent}/update/${selectRowData.vessels.id}`,
            inputData,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authtoken}`,
              },
            }
          )
          .then((response) => {
            setVesselCode("");
            setVesselDesc("");
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            toast.error("error ekak", {
              position: toast.POSITION.TOP_RIGHT,
            });
          });
      } else {
        toast.error("Please Select data Row", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      const duplicate = data.some((el) => el.vessel_code === VesselCode);
      if (duplicate == true) {
        toast.error("This Vessel code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else if (duplicate == false) {
        if (VesselCode.length == 0) {
          toast.error("Vessel Code can not be empty", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setVesEmpty(true);
          return;
        } else {
          setVesEmpty(false);
        }
        if (VesselDesc.length == 0) {
          toast.error("Vessel Description can not be empty", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setVesDescEmpty(true);
          return;
        } else {
          setVesDescEmpty(false);
        }
        if (selectRowData !== "") {
          const inputData = {
            vessel_code: VesselCode,
            vessel_description: VesselDesc,
            active_status: isChecked ? 1 : 0,
          };
          axios
            .post(
              `${baseUrl}${pageComponent}/update/${selectRowData.vessels.id}`,
              inputData
            )
            .then((response) => {
              setVesselCode("");
              setVesselDesc("");
              toast.success("Successfully Save Data ! ", {
                position: toast.POSITION.TOP_RIGHT,
              });
              setTimeout(window.location.reload.bind(window.location), 2000);
            })
            .catch((error) => {
              toast.error("error ekak", {
                position: toast.POSITION.TOP_RIGHT,
              });
            });
        } else {
          alert("Please Select data Row");
        }
      }
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    const duplicate = await data.some((el) => el.vessel_code === VesselCode);
    const inputData = {
      vessel_code: VesselCode,
      vessel_description: VesselDesc,
      Active: isChecked ? 1 : 0,
    };
    if (VesselCode.length == 0) {
      toast.error("Vessel Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setVesEmpty(true);
    } else {
      setVesEmpty(false);
    }

    if (VesselDesc.length == 0) {
      toast.error("Vessel Description can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setVesDescEmpty(true);
      return;
    } else {
      setVesDescEmpty(false);
    }

    if (duplicate == true) {
      toast.error("This Vessel code already included", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (duplicate == false) {
      axios
        .post(`${baseUrl}${pageComponent}/store`, inputData, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authtoken}`,
          },
        })
        .then((response) => {
          setVesselCode("");
          setVesselDesc("");
          toast.success("Successfully Saved Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          toast.error("error", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.vessels);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken]);

  // useEffect(() => {
  //   fetch(
  //     `${baseUrl}reports/2023-06-07 00:00:00/2023-06-16 04:05:00/jobtypewiserevenuereport`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setBookingReportData(data.job_type_wise_revenue);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, []);

  const deleteRow = async (event) => {
    event.preventDefault();
    try {
      await axios.delete(
        `${baseUrl}${pageComponent}/destroy/${selectRowData.vessels.id}`, // Correct URL format
        {
          headers: {
            Authorization: `Bearer ${authtoken}`,
          },
        }
      );

      toast.warning("Successfully Deleted Data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });

      setTimeout(() => {
        window.location.reload(); // Reload the page after deletion
      }, 2000);
    } catch (error) {
      console.error("Error deleting row:", error);
      // Handle error and display a message if needed
    }
  };

  const columns = ["vessel_code", "vessel_description", "active_status"];
  const tTitle = ["Vessel Code", "Vessel Description", "Active Status"];
  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>VesCode</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    placeholder="VesCode"
                    readOnly={selectRowData !== "" ? true : false}
                    className={vesEmpty == true ? "border-red2" : ""}
                    name="VesselCode"
                    value={VesselCode}
                    onChange={(e) => setVesselCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>VesDesc</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="VesDesc"
                    autoComplete="off"
                    className={vesDescEmpty == true ? "border-red2" : ""}
                    name="VesselDesc"
                    value={VesselDesc}
                    onChange={(e) => setVesselDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3 " controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label="Active"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </Form.Group>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={handleButtonClickPDF}
                  disabled={btnActive}
                >
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
                <div>
                  {showPDFGenerator ? (
                    <PDFGenerator />
                  ) : (
                    <GenerateButton onClick={handleButtonClickPDF} />
                  )}
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <PDFGenerator data={bookingReportData} />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <div>
            <button onClick={handleGenerateReport}>Generate Report</button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Vessel;
